export default "__VITE_ASSET__CqmCyvwy__"